import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, DatePicker, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../trialBalanceSlice";
import { fetchTrialBalance } from "../trialBalanceThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import dayjs from "dayjs";
import { currentDateEndTime, currentDateEndTime2, dateTimeFormat, toCompanyDateOnlyforReportDateFilter } from "../../../../lib/functions";
import Swal from "sweetalert2";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import useMigrationDate from "../../../../hooks/useMigrationDate";

const TrialBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.trialBalance);
  const { disabledDate } = useMigrationDate();

  useDefaultDateRange(setFilters, filters, "today");

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    dispatch(fetchTrialBalance({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        style={{ alignItems: "center" }}
      >
         <Col xs={24} sm={12} md={6}>
                <label>Filter Type</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Filter Type"
                  value={ filters.filterType
                || undefined}
                  onChange={(value) => handleFilterChange("filterType", value)}
                  options={[
                    { label: "Life Time", value: "Life Time" },
                    { label: "Date Wise", value: "Date Wise" },
                  ]}
                />
              </Col>
       

        {filters.filterType === "Date Wise" && (
          <Col xs={24} sm={12} md={6}>
            <label className="form-label-nowrap">
              <span style={{ color: "#ff4d4f" }}>*</span> To Date
            </label>
            <DatePicker
              size="large"
              value={
                filters.toDate
                  ? toCompanyDateOnlyforReportDateFilter(filters.toDate)
                  : null
              }
              data-testid="to-datepicker"
              onChange={(v) => {
                if (!v) {
                  handleFilterChange("toDate", null);
                  return;
                }
                const isoEnd = currentDateEndTime2(v);
                // if (
                //   filters.fromDate &&
                //   dayjs(isoEnd).isBefore(dayjs(filters.fromDate))
                // ) {
                //   Swal.fire({
                //     icon: "warning",
                //     title: "Invalid Date",
                //     text: "To Date cannot be before From Date.",
                //     confirmButtonColor: "#1677ff",
                //   });
                //   return;
                // }
                handleFilterChange("toDate", isoEnd);
              }}
              style={{ width: "100%" }}
              format={dateTimeFormat}
              disabledDate={disabledDate}
            />
          </Col>
        )}

        <Col
          xs={24}
          sm={12}
          md={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            data-testid="report-btn"
            style={{height:35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
      
    </Card>
  );
};

export default TrialBalanceFilters;
